import api, { publicApi } from './api';

export const companyService = {
  createCompany: (data) => api.post('/companies', data),
  getMyCompany: () => api.get('/companies/my-company'),
  updateMyCompany: (data) => api.put('/companies/my-company', data),
};

export const assessmentService = {
  createAssessment: (data) => api.post('/assessments', data),
  getAssessment: (id) => api.get(`/assessments/${id}`),
  getAssessmentsByCompany: (companyId) =>
    api.get(`/assessments/company/${companyId}`),
  updateStatus: (id, status) =>
    api.put(`/assessments/${id}/status`, { status }),
  deleteAssessment: (id) => api.delete(`/assessments/${id}`),
  createFollowUp: (id) => api.post(`/assessments/${id}/follow-up`),
  downloadReport: (id) => api.get(`/assessments/${id}/report`, { responseType: 'blob' }),
  // Maßnahmen-Teaser (AUD-57): Metadaten + 1–2 Vorschau-Maßnahmen aus dem echten Audit.
  getMeasuresTeaser: (id) => api.get(`/assessments/${id}/measures-teaser`),
};

export const templateService = {
  getTemplates: () => api.get('/templates'),
};

export const questionService = {
  getAllQuestions: (templateId) => api.get('/questions', { params: templateId ? { template: templateId } : {} }),
  getQuestionsByCategory: (category) =>
    api.get(`/questions/category/${category}`),
  saveAnswer: (data) => api.post('/answers', data),
  getAnswersByAssessment: (assessmentId) =>
    api.get(`/answers/assessment/${assessmentId}`),
  getAnswer: (assessmentId, questionId) =>
    api.get(`/answers/${assessmentId}/${questionId}`),
  updateUmsetzungsStatus: (data) => api.put('/answers/progress', data),
};

export const notificationSettingsService = {
  getMySettings: () => api.get('/notification-settings/my-settings'),
  updateMySettings: (data) => api.put('/notification-settings/my-settings', data),
  sendTestEmail: () => api.post('/notification-settings/test-email'),
};

export const roadmapService = {
  getRoadmap: (assessmentId) => api.get(`/roadmaps/${assessmentId}`),
};

export const consentService = {
  // Liefert Disclaimer-Text + Version + ob der Nutzer diese Version akzeptiert hat.
  getSelfAssessmentDisclaimer: () => api.get('/consents/self-assessment'),
  // Protokolliert die Zustimmung zur aktuellen Disclaimer-Version.
  acceptSelfAssessmentDisclaimer: () => api.post('/consents/self-assessment'),
};

// Anonymer Audit-Flow (AUD-53) — ohne Login, über publicApi (httpOnly-Cookie).
export const anonymousAuditService = {
  // opts: { _hp?, 'cf-turnstile-response'? } — Honeypot + optionales Turnstile-Token.
  start: (opts) => publicApi.post('/public/audits', opts || {}),
  getCurrent: () => publicApi.get('/public/audits/current'),
  getQuestions: () => publicApi.get('/public/audits/questions'),
  // Kennzahlen für die Intro-Seite (AUD-62): Anforderungen, Themenbereiche inkl.
  // Fragenanzahl, Maximalpunkte und geschätzte Dauer — aus dem Fragenkatalog abgeleitet.
  getCatalog: () => publicApi.get('/public/audits/catalog'),
  saveAnswer: (data) => publicApi.post('/public/audits/answers', data),
  complete: () => publicApi.post('/public/audits/complete'),
  getResult: () => publicApi.get('/public/audits/result'),
  // Fortsetzen-Link (AUD-63). Anfordern setzt den Cookie voraus (eigenes Audit);
  // das Einlösen läuft bewusst ohne — genau dafür existiert der Link.
  // opts: { email, _hp?, 'cf-turnstile-response'? }
  requestResumeLink: (opts) => publicApi.post('/public/audits/resume-link', opts || {}),
  redeemResumeLink: (token) => publicApi.post('/public/audits/resume', { token }),
};

// Audit-Claiming (AUD-54): bindet ein anonymes Audit an den eigenen Tenant. Der
// Request braucht beides — den Clerk-Bearer (api-Interceptor) UND den anonymen
// httpOnly-Cookie — daher withCredentials auf genau diesem api-Aufruf.
export const claimService = {
  claimAnonymousAudit: () => api.post('/claims', {}, { withCredentials: true }),
};

export const paymentService = {
  getSubscription: () => api.get('/payments/subscription'),
  // Plan-Katalog (AUD-61): Name, Preis, Intervall, Leistungsmerkmale je Plan.
  // Einzige Preisquelle des Frontends — keine hartcodierten Beträge in der UI.
  getPlans: () => api.get('/payments/plans'),
  createCheckoutSession: () => api.post('/payments/checkout'),
  // opts: { returnPath?, cancel? } — returnPath = app-interner Rücksprungpfad,
  // cancel = true öffnet direkt den Kündigungs-Flow des Portals.
  createPortalSession: (opts) => api.post('/payments/portal', opts || {}),
  // Nur im lokalen Mock-Modus (PAYMENT_PROVIDER=mock) genutzt.
  completeMockCheckout: (sessionId, outcome) => api.post('/payments/mock/complete', { sessionId, outcome }),
};
